/**
 * 商城切换
 */
import { cartMobx, restaurantConfig, restaurantCenter, RESTAURANT_EVENT } from 'restaurant'
import { mallCenter } from '@mobx/mall'
import { memberMobx } from '@mobxStore'
import { mpc } from '@dt/mmg-sdk'

class MallChangeController {
  static isInitMpc = false
  // 如果从商城回来，就切换eatType
  static menuSwitchEatType (type: string = 'menu') {
    let _mpc: any = mpc
    let eatType = _mpc && _mpc.eatType
    console.log('🍰开始切换1', type)
    console.log('🍰开始切换2', 'eatType', eatType)
    if (type === 'mall' && eatType !== 'mall') {
      console.log('🍰开始切换3 mall')
      restaurantConfig.mpc.setOption({
        channel: 'mobile',
        eatType: 'mall'
      })
      mallCenter.emit(RESTAURANT_EVENT.MENU_MALL_CHANGE)
    } else if (type !== 'mall') {
      console.log('🍰开始切换3 menu')
      restaurantConfig.mpc.setOption({
        channel: cartMobx.channel,
        eatType: cartMobx.info?.eatType || Config.eatType || 'dinein'
      })
      restaurantConfig.mpc.switchStore(restaurantConfig.storeId)
      restaurantCenter.emit(RESTAURANT_EVENT.MENU_MALL_CHANGE)
    }
    // mkt 获取用户信息
    if (Config.token && !this.isInitMpc) {
      this.isInitMpc = true
      memberMobx.initMpc()
    }
  }
}

export default MallChangeController
